/*
 * Shared Styles Package
 * This package defines shared CSS styles that can be used
 * by frameworks including Polymer and Lit-based components.
 */

export const sharedStyles = `
:host {
    /*
        Sets the icons on the header to the icon color in the palette for the app.
        Sets the background color of the header to the primary color of the palette of the app
    */
    --cbar-header-app-drawer-toolbar: var(--cbar-sys-color-surface, var(--cbar-sys-color-primary, #004CA2));
    --cbar-header-app-drawer-on-toolbar: var(--cbar-sys-color-on-surface, var(--cbar-icon-text, white));

    /*
        Sets all the input elements in the app to the primary color of the app
    */
    --paper-input-container-underline-focus-border: var(--cbar-sys-color-primary, #004CA2);
}
:root, :host, html, body{
    font-size: 14px;
}

a{
    color: var(--cbar-sys-color-secondary, var(--cbar-dark-primary-color, #003F83))
}
.sub-header-div{
    margin-left: 5%;
    margin-top: var(--subheader-top-margin, 65px);;
}
/*  Div styling for tabs container, fixed height to calculate the page start height, positioned under the header bar    */
#tabs-div {
    position: fixed;
    top: calc(env(safe-area-inset-top, 0) + 64px);
    left: 0;
    right: 0;
}
/*  Header spacer in order to start the content of a page underneath the tabs so they dont get wrapped behind such */
#header-spacer {
    /* Header height + tab height */
    height: 64px;
}
/* Standard paper buttons should follow the secondary or "dark primary" color of the color palette */
paper-button{
    color: var(--cbar-sys-color-primary, var(--cbar-dark-primary-color, #003F83));
}
/*  Raised paper buttons should be the primary color*/
paper-button[raised] {
    background-color: var(--cbar-sys-color-primary-container, var(--cbar-dark-primary-color, #003F83));
    color: var(--cbar-sys-color-on-primary-container, var(--cbar-icon-text, white));
    width: 25%;
}
/* styling used for chips or the cbar-category-button element */
.chip-button{
    background-color: var(--cbar-sys-color-secondary, var(--cbar-dark-primary-color, #003F83));
    color: var(--cbar-sys-color-on-secondary, var(--cbar-icon-text, white));
    -webkit-transition: width 0.5s; /* For Safari 3.1 to 6.0 */
    transition: width 0.5s;
    text-align: center;
    margin-bottom: 10px;
    font-size: 14px;
}
/* centered div both vertically and horizontally, takes up the whole container*/
.body-display-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    flex-direction: column;
}
/* small div horizontally centered*/
.centered {
    padding: 0;
    margin: 0;
    align-self: center;
    width: 25%;
}
/*  Title headers should all be the same text, weight and color to indicate site styling    */
h1, h2, h3, h4, h5, h6, .sub-text{
    font-family: Roboto ,sans-serif;
    color: var(--cbar-sys-color-primary, var(--cbar-dark-primary-color, #003F83));
    line-height: normal;
    margin: 16px 0;
}
h1{
    font-size: var(--cbar-typescale-display-large-size, 6.5rem);
    letter-spacing: var(--cbar-typescale-display-large-spacing, -1.5px);
    font-weight: var(--cbar-typescale-display-large-weight, lighter);
}
h2{
    font-size: var(--cbar-typescale-display-medium-size, 4.2rem);
    letter-spacing: var(--cbar-typescale-display-medium-spacing, 0.5px);
    font-weight: var(--cbar-typescale-display-medium-weight, lighter);
}
h3{
    font-size: var(--cbar-typescale-display-small-size, 3.4rem);
    letter-spacing: var(--cbar-typescale-display-small-spacing, 0px);
    font-weight: var(--cbar-typescale-display-small-weight, normal);
}
h4{
    font-size: var(--cbar-typescale-headline-large-size, 2.4rem);
    letter-spacing: var(--cbar-typescale-headline-large-spacing, 0.25px);
    font-weight: var(--cbar-typescale-headline-large-weight, normal);
}
h5{
    font-size: var(--cbar-typescale-headline-medium-size, 1.7rem);
    font-weight: var(--cbar-typescale-headline-medium-weight, normal);
    letter-spacing: var(--cbar-typescale-headline-medium-spacing, 0px);
}
h6{
    font-size: var(--cbar-typescale-headline-small-size, 1.42rem);
    letter-spacing: var(--cbar-typescale-headline-small-spacing, 0.15px);
    font-weight: var(--cbar-typescale-headline-small-weight, normal);
}
.sub-title{
    font-size: var(--cbar-typescale-title-medium-size, 1.25rem);
    letter-spacing: var(--cbar-typescale-title-medium-spacing, 0.15px);
    font-weight: var(--cbar-typescale-title-medium-weight, normal);
}
.sub-title-2{
    font-size: var(--cbar-typescale-title-small-size, 1rem);
    letter-spacing: var(--cbar-typescale-title-small-spacing, 0.1px);
    font-weight: var(--cbar-typescale-title-small-weight, normal);
}
.body-text{
    font-size: var(--cbar-typescale-body-large-size, 1.25rem);
    letter-spacing: var(--cbar-typescale-body-large-spacing, 0.5px);
    font-weight: var(--cbar-typescale-body-large-weight, normal);
}
.body-text-2{
    font-size: var(--cbar-typescale-body-medium-size, 1rem);
    letter-spacing: var(--cbar-typescale-body-medium-spacing, 0.25px);
    font-weight: var(--cbar-typescale-body-medium-weight, normal);
}
.caption-text{
    font-size: var(--cbar-typescale-body-small-size, 0.75rem);
    letter-spacing: var(--cbar-typescale-body-medium-spacing, 0.4px);
    font-weight: var(--cbar-typescale-body-small-weight, normal);
}
mwc-button {
    --mdc-theme-primary: var(--cbar-sys-color-primary, #004CA2);
    --mdc-theme-on-primary: var(--cbar-sys-color-on-primary, var(--cbar-icon-text, white));
}
/* Titles that are in place on coloured backgrounds, used in cbar-entity-card */
.background-coloured-title{
    color: var(--cbar-icon-text, white);
}
/* slim font class for those that we want to match the header font styles */
.slim-font{
    font-weight: 200;
}
/* div styling used for ending action buttons floating left to align with text*/
.ending-div{
    margin-top: 5%;
    margin-left: -3%;
}
paper-fab{
    background-color: var(--cbar-sys-color-primary-container, var(--cbar-sys-color-primary, #004CA2));
    color: var(--cbar-sys-color-on-primary-container, var(--cbar-icon-text, white));
}

paper-card *:is(paper-input, paper-dropdown-menu), paper-dialog *:is(paper-input, paper-dropdown-menu){
    color: var(--cbar-sys-color-on-surface, black)
}
/* page fab styles, this allows for the page fab to sit statically on the bottom right of the page*/
.page-fab{
    position: fixed;
    right: 8px;
    bottom: 18px;
    z-index: 1;
}

paper-card, cbar-entity-card{
    border-radius: 4px;
    background: var(--cbar-card-background-color, var(--cbar-sys-color-surface-container, white));
    color: var(--cbar-card-color, var(--cbar-sys-color-on-surface, black));
}

iron-pages{
    background-color: var(--cbar-sys-color-surface, white);
    color: var(--cbar-sys-color-on-surface, black);
}

cbar-header{
    --cbar-header-background-color: var(--cbar-sys-color-surface, var(--cbar-sys-color-primary, white));
    --cbar-header-color: var(--cbar-sys-color-on-surface, var(--cbar-icon-text, black));
}

/* simple right alignment class */
.right-aligned{
    float: right;
}
/* flexbox class that has spacing between the items */
.center-aligned-spaced{
    display: flex;
    justify-content: space-evenly;
}
paper-dialog{
    --paper-dialog-background-color: var(--cbar-sys-color-surface, white) !important;
    --paper-dialog-color: var(--cbar-sys-color-on-surface, black) !important;
}
/* paper tabs should follow the colouring style of the palette being the secondary colour being accented with the accent color and the text should be the icon text */
paper-tabs{
    --paper-tabs-selection-bar-color: var(--cbar-sys-color-primary, var(--cbar-accent-color, #FFC300));
    --paper-tab-ink: var(--cbar-sys-color-primary, var(--cbar-accent-color, #FFC300));
    background-color: var(--cbar-sys-color-surface, var(--cbar-dark-primary-color, white));
    color: var(--cbar-sys-color-on-surface, var(--cbar-icon-text, black));
}
paper-toast, #toast{
    background-color: var(--cbar-entity-summary-toast-background, var(--cbar-sys-color-inverse-surface, var(--cbar-dark-primary-color, #003F83)));
    color:  var(--cbar-sys-color-inverse-on-surface, white);
}
paper-toast > paper-button, #toast > paper-button{
    color: var(--cbar-sys-color-inverse-on-surface, white);
}
mwc-tab{
    --mdc-theme-primary: var(--cbar-sys-color-primary, var(--cbar-accent-color, #FFC300));
}

/*  links inside the tabs that hide the hyperlink and the color of the text */
paper-tab a{
    @apply --layout-horizontal;
    @apply --layout-center-center;

    font-size: 16px;
    text-decoration: none;
    color: var(--cbar-sys-color-on-surface, var(--cbar-icon-text, white));
}
/* styling for an apps offline message card, shows when the site is offline. */
.offline-card {
    background: var(--cbar-sys-color-secondary, var(--cbar-dark-primary-color, #003F83));
    color: var(--cbar-sys-color-on-secondary, var(--cbar-icon-text, white));
    align-self: flex-end;
    margin-right: 1%;
}
/* used for the hidden$= check, sets display to none if true*/
[hidden]{
    display: none !important;
}
/* datepicker styles should follow the rest of the site, using the majority of the colour palette*/
cbar-date-time-picker{
    --default-primary-color: var(--cbar-sys-color-primary, var(--cbar-dark-primary-color, #003F83));
    --text-primary-color: var(--cbar-sys-color-on-primary, var(--cbar-icon-text, white));
    --paper-dialog-button-color : var(--cbar-sys-color-tertiary, var(--cbar-accent-color, #FFC300));
}
/*  if a category of data isn't present, use this styling to display such under a header*/
.no-data{
    text-align: center;
    margin-top: 5%;
    margin-bottom: 5%;
}

.horizontal-scroll{
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-bottom: 10px;
    /*This fixes the height of the cards that are within the div to be the same height*/
    display: flex;
}
.horizontal-scroll::-webkit-scrollbar{
    background: transparent;
    width: 0;
}
.horizontal-scroll::-webkit-scrollbar{
    overflow: -moz-scrollbars-none;
}

cbar-entity-card{
    width: 290px;
    margin: 8px 8px;
    animation: fadeIn 0.5s;
    white-space: normal;
    vertical-align: top;
    flex-shrink: 0;
}

@media (max-width: 615px){
    cbar-entity-card{
        width: 100%;
        max-width: 400px;
    }
}

cbar-entity-summary{
    position: absolute;
    left: 0;
    right: 0;
    margin-top: -8px;
}
cbar-search-bar {
    --cbar-search-bar-background-color: var(--cbar-sys-color-surface, white);
    --cbar-search-bar-icon-color: var(--cbar-sys-color-inverse-on-surface, black);
    --cbar-search-bar-text-color: var(--cbar-sys-color-inverse-on-surface, black);
    /* for new mdc styles */
    --mdc-text-field-fill-color: var(--cbar-sys-color-inverse-surface, var(--cbar-icon-text, white));
    --mdc-theme-primary: var(--cbar-sys-color-inverse-on-surface, var(--cbar-sys-color-primary, #004CA2));
    --mdc-text-field-ink-color: var(--cbar-sys-color-inverse-on-surface,  var(--cbar-sys-color-primary, #004CA2));
    --mdc-text-field-label-ink-color: var(--cbar-sys-color-inverse-on-surface,  var(--cbar-sys-color-primary, #004CA2));
    --mdc-text-field-idle-line-color: var(--cbar-sys-color-inverse-on-surface,  var(--cbar-sys-color-primary, #004CA2));
    --mdc-text-field-hover-line-color: var(--cbar-sys-color-inverse-on-surface,  var(--cbar-sys-color-primary, #004CA2))
}

paper-dropdown-menu, paper-input, gold-cc-expiration-input, paper-checkbox, paper-listbox{
    --paper-input-container-color: var(--cbar-sys-color-on-surface, black);
    --paper-listbox-background-color: var(--cbar-sys-color-surface, white);
    --paper-listbox-color: var(--cbar-sys-color-on-surface, black);
    --primary-text-color: var(--cbar-sys-color-on-surface, black);
    color: var(--cbar-sys-color-on-surface, black);
}

.loading {
    position: relative;
    overflow: hidden;
    background-color: #e9ebee;
}

.loading::after{
    content: "";
    display: block;
    background-color: #dddfe2;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    transform: translateX(0);
    animation: 1.5s loading-placeholder ease-in-out infinite;
}

mwc-textfield, mwc-textarea, mwc-select{
    --mdc-theme-primary: var(--cbar-sys-color-primary, #004CA2);
    --mdc-text-field-filled-border-radius: var(--cbar-text-field-filled-border-radius);
    --mdc-text-field-idle-line-color: var(--cbar-text-field-idle-line-color, var(--cbar-sys-color-primary));
    --mdc-text-field-hover-line-color: var(--cbar-text-field-hover-line-color, var(--cbar-sys-color-on-surface));
    --mdc-text-field-disabled-line-color: var(--cbar-text-field-disabled-line-color, var(--cbar-sys-color-on-surface-variant, grey));
    --mdc-text-field-outlined-idle-border-color: var(--cbar-text-field-outlined-idle-border-color, var(--cbar-sys-color-primary));
    --mdc-text-field-outlined-hover-border-color: var(--cbar-text-field-outlined-hover-border-color, var(--cbar-sys-color-on-surface));
    --mdc-text-field-outlined-disabled-border-color: var(--cbar-text-field-outlined-disabled-border-color, var(--cbar-sys-color-on-surface));
    --mdc-text-field-fill-color: var(--cbar-text-field-fill-color, var(--cbar-sys-color-surface-container-highest, transparent));
    --mdc-text-field-disabled-fill-color: var(--cbar-text-field-disabled-fill-color, var(--cbar-sys-color-surface-container-lowest));
    --mdc-text-field-ink-color: var(--cbar-text-field-ink-color, var(--cbar-sys-color-on-surface, black));
    --mdc-text-field-label-ink-color: var(--cbar-text-field-label-ink-color, var(--cbar-sys-color-primary, #004CA2));
    --mdc-text-field-disabled-ink-color: var(--cbar-text-field-disabled-ink-color, var(--cbar-sys-color-on-surface-variant, grey));
    --mdc-select-fill-color: var(--cbar-text-field-fill-color, var(--cbar-sys-color-surface-container-highest, transparent));
}

h4.page-header-align{
    margin-left: 16px
}

h5.page-header-align{
    margin-left: 18px;
}

mwc-checkbox{
    --mdc-theme-secondary: var(--cbar-sys-color-secondary, var(--cbar-dark-primary-color, #003F83));
}
md-dialog{
    --md-dialog-container-color: var(--cbar-dialog-container-color, var(--cbar-sys-color-surface, white));
    --md-dialog-headline-color: var(--cbar-dialog-headline-color, var(--cbar-sys-color-on-surface, black));
    --md-dialog-headline-font: var(--cbar-dialog-headline-font, var(--cbar-sys-typescale-headline-small-font, Roboto));
    --md-dialog-supporting-text-color: var(--cbar-dialog-supporting-text-color, var(--cbar-sys-color-on-surface-variant, black));
    --md-dialog-supporting-text-font: var(--cbar-dialog-supporting-text-font, var(--cbar-sys-typescale-body-medium-font, Roboto));
    z-index: 2;
}

@keyframes loading-placeholder {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}
`;
